"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = _default;
exports.useSeriesContext = exports.SeriesContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var SeriesContext = /*#__PURE__*/(0, _react.createContext)(null);
exports.SeriesContext = SeriesContext;

function _default(props) {
  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      lastAnswerWasCorrect = _useState2[0],
      setLastAnswerWasCorrect = _useState2[1];

  var _useState3 = (0, _react.useState)(-1),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      curDialogIndex = _useState4[0],
      setCurDialogIndex = _useState4[1];

  return /*#__PURE__*/_react["default"].createElement(SeriesContext.Provider, {
    value: {
      curDialogIndex: curDialogIndex,
      setCurDialogIndex: setCurDialogIndex,
      lastAnswerWasCorrect: lastAnswerWasCorrect,
      setLastAnswerWasCorrect: setLastAnswerWasCorrect
    }
  }, props.children);
}

var useSeriesContext = function useSeriesContext() {
  return (0, _react.useContext)(SeriesContext);
};

exports.useSeriesContext = useSeriesContext;